import { useEffect } from "react";
import { Navigate } from "react-router-dom";

/* Anciennes URL et libellés de menu tapés à la main (/sets, /archive). Le visiteur est
   envoyé sur l'URL canonique sans délai ; pour les moteurs, la page se déclare noindex et
   pointe son canonical vers la cible, ce qui consolide le signal sur une seule URL. */
export default function LegacyRedirect({ to }) {
  useEffect(() => {
    const robots = document.createElement("meta");
    robots.setAttribute("name", "robots");
    robots.setAttribute("content", "noindex, follow");
    document.head.appendChild(robots);
    const link = document.createElement("link");
    link.setAttribute("rel", "canonical");
    link.setAttribute("href", `${window.location.origin}${to}`);
    document.head.appendChild(link);
    return () => { robots.remove(); link.remove(); };
  }, [to]);
  return <Navigate to={to} replace data-testid="legacy-redirect" />;
}
